export default {
      id: "icon-enter-usage",
      viewBox: "0 0 612 514.99",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-enter",
      toString: function () {
        return this.url;
      }
    }